const DiscountCodes = new Map();
DiscountCodes.set('TEST-1-DOLLAR', {
    amount: -1,
    code: 'TEST-1-DOLLAR',
});
DiscountCodes.set('20-PERCENT-1PACK', {
    code: '20-PERCENT-1PACK',
    percent: -0.2,
});
DiscountCodes.set('54-PERCENT-3PACK', {
    code: '54-PERCENT-3PACK',
    percent: -0.54,
});
DiscountCodes.set('60-PERCENT-5PACK', {
    code: '60-PERCENT-3PACK',
    percent: -0.6,
});
export default DiscountCodes;
